import { Theme } from '@mui/material/styles'

const muiTab = (theme: Theme) => {
  return {
    defaultProps: {
      disableRipple: true,
      disableFocusRipple: true,
      disableTouchRipple: true
    },
    styleOverrides: {
      root: {
        padding: '0.5rem 0px',
        minWidth: 'auto',
        textTransform: 'inherit',
        fontSize: '0.875rem',
        color: theme.colors.disabled
      }
    }
  }
}

export default muiTab
